var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActivitiesList',{attrs:{"adult_activities":_vm.adult_acts,"child_activities":_vm.child_acts}})
}
var staticRenderFns = []

export { render, staticRenderFns }